import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-telescope',
  templateUrl: './telescope.component.html',
  styleUrls: ['./telescope.component.scss']
})
export class TelescopeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
